export default __webpack_public_path__ + "static/media/050-writer.1cdab20d.svg";